import type { TMessages } from '@/types/TMessages'

export const messages = {
  labels: {
    name: 'Введите ваше имя',
    phone: 'Введите ваш телефон',
    email: 'Введите ваш E-mail',
    regions: 'Регион работы',
  },
  errors: {
    required: 'Необходимо заполнить',
    region: 'Выберите минимум один регион',
  },
} satisfies TMessages
